/* ============================================================
   SPORT NATION — motion engine
   Scroll reveals, parallax, counters, magnetic pull, tilt.
   Everything respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('[data-sn-reveal]:not(.sn-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sn-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sn-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- counters ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-sn-count-to')) || 0;
    var suffix = el.getAttribute('data-sn-count-suffix') || '';
    var dur = 1600;
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-sn-count-to]:not([data-sn-counted])');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-sn-counted', '');
        el.textContent = el.getAttribute('data-sn-count-to') + (el.getAttribute('data-sn-count-suffix') || '');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-sn-counted', '');
            animateCount(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax ---------- */
  var parallaxEls = [];
  var ticking = false;

  function parallaxFrame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxEls.length; i++) {
      var item = parallaxEls[i];
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) continue;
      var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
      var shift = -progress * item.strength * rect.height;
      item.target.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(parallaxFrame);
    }
  }

  function initParallax(root) {
    if (reduced) return;
    var els = (root || document).querySelectorAll('[data-sn-parallax]:not([data-sn-parallax-init])');
    els.forEach(function (el) {
      el.setAttribute('data-sn-parallax-init', '');
      var target = el.querySelector('.sn-parallax-layer') || el.querySelector('img');
      if (!target) return;
      parallaxEls.push({
        el: el,
        target: target,
        strength: parseFloat(el.getAttribute('data-sn-parallax')) || 0.12,
      });
    });
    if (parallaxEls.length && !initParallax.bound) {
      initParallax.bound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- magnetic buttons ---------- */
  function initMagnetic(root) {
    if (reduced || window.matchMedia('(hover: none)').matches) return;
    var els = (root || document).querySelectorAll('[data-sn-magnetic]:not([data-sn-magnetic-init])');
    els.forEach(function (el) {
      el.setAttribute('data-sn-magnetic-init', '');
      var strength = 12;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        el.style.translate = x * strength + 'px ' + y * strength + 'px';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'translate .5s cubic-bezier(.34,1.56,.64,1)';
        el.style.translate = '0px 0px';
        setTimeout(function () { el.style.transition = ''; }, 500);
      });
    });
  }

  /* ---------- tilt cards ---------- */
  function initTilt(root) {
    if (reduced || window.matchMedia('(hover: none)').matches) return;
    var els = (root || document).querySelectorAll('[data-sn-tilt]:not([data-sn-tilt-init])');
    els.forEach(function (el) {
      el.setAttribute('data-sn-tilt-init', '');
      el.style.transformStyle = 'preserve-3d';
      var raf = null;
      el.addEventListener('mousemove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform =
            'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-4px)';
        });
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
        setTimeout(function () { el.style.transition = ''; }, 600);
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(root) {
    initReveals(root);
    initCounters(root);
    initParallax(root);
    initMagnetic(root);
    initTilt(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Re-init inside Shopify theme editor when sections re-render */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
